module.exports = __webpack_public_path__ + "img/exampleCard.ba70ff21.png";